import { Text, Box } from '@cdl/heartbeat-react';
import { ClassificationLabel } from './ClassificationLabel';
import { Cluster } from '../../clustering.types';

interface Props {
  cluster: Cluster;
}

export const BaseClusterInformation: React.FC<Props> = ({ cluster }) => {
  if (cluster == null) {
    return <></>;
  }
  return (
    <Box userSelect='none'>
      <Text
        position='absolute'
        right='xs'
        px='xs'
        bg='neutral.0'
        borderRadius='md'
      >
        {cluster.beats.length}
      </Text>
      {cluster.classification !== 'Unclassified' && (
        <ClassificationLabel classification={cluster.classification} />
      )}
    </Box>
  );
};
